import React, { useEffect, useRef } from 'react';
// import useWindowDimensions from '../theme/useWindowDimensions';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
// import CloseIcon from '@material-ui/icons/Close';

import { isSameUser, isATaggedMsg } from '../constants/liveStreamHelper';
import { taggedContColor, chatHandleInMsg } from '../constants/colorsCustom';

const useStyles = makeStyles((theme) => ({
  gridOccupy: {
    display: 'flex',
    flexDirection: 'column-reverse',
    listStyle: 'none',
    width: '100%',
    overflow: 'hidden',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(104,97,88,1)',
      // outline: "1px solid slategrey",
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    borderRadius: 0,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
    },
  },
  actionArea: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '80%',
  },
  image: {
    maxHeight: 140,
    width: theme.spacing(15),
    height: theme.spacing(15),
    objectFit: 'cover',
    overflow: 'hidden',
    borderRadius: theme.spacing(2),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    backgroundColor: '#fff',
    marginLeft: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    color: '#000',
    borderRadius: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(0.5),
    },
  },

  nameContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    width: '100%',
  },
  nameClass: {
    textTransform: 'capitalize',
    color: '#808B96', //a9a9a9 --old
    fontSize: 12,
    fontFamily: 'Lato',

    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },

  actions: {
    display: 'flex',
    flexDirection: 'column',
  },
  logo: {
    objectFit: 'cover',
    overflow: 'hidden',
  },
  time: {
    // paddingLeft: theme.spacing(1),
  },

  msgClass: {
    fontSize: 12,
    fontFamily: 'Lato',
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },

  // closeBtn: {
  //   // backgroundColor: "blue",
  //   // color: "white",
  //   // padding: "16px 20px",
  //   border: "none",
  //   cursor: "pointer",
  //   opacity: "0.8",
  //   position: "fixed",
  //   top: "40px",
  //   right: "20px",
  //   width: "30px",
  //   height: "30px",
  //   borderRadius: "50%",
  //   zIndex: 100,
  //   textAlign: "center",
  //   display: "grid",
  //   placeItems: "center",
  //   // "&:hover": {
  //   //   backgroundColor: "#00acc1",
  //   // },
  //   [theme.breakpoints.down("sm")]: {
  //     display: "block",
  //   },
  //   [theme.breakpoints.up("sm")]: {
  //     display: "none",
  //   },
  // },

  // cancelIcon: {
  //   backgroundColor: "red",
  //   borderRadius: "50%",
  //   height: "30px",
  //   width: "30px",
  // },
}));

function Comment(props) {
  const classes = useStyles();
  const scrollRef = useRef(null);
  // const { height } = useWindowDimensions();
  const data = props.data;
  // const identity = props?.identity?.toLowerCase();
  const identity = props?.identity;

  const manageMsg = (msg) => {
    const msgArray = msg.split(' ');

    return msgArray.map((each, index) => {
      const x = each.slice(0, 1);
      if (x === '@') {
        return (
          <span style={{ color: chatHandleInMsg }} key={index}>
            {each}{' '}
          </span>
        );
      }
      return each + ' ';
    });
  };

  useEffect(() => {
    scrollRef.current.scrollTop = 0;
    props.clearMsgNotification();
  }, [data]);

  return (
    <Grid
      component="div"
      className={classes.gridOccupy}
      style={{
        overflowY: 'scroll',
        // height: 0.37 * height,
        height: '100%',
        width: '100%',
      }}
      ref={scrollRef}
    >
      <div style={{ overflowWrap: 'anywhere' }}>
        {data.map((each, index) => {
          // const msgIdentity = each?.identity?.toLowerCase();
          // const msgIdentity = each?.identity; //string
          // +msgIdentity === +identity
          const isMsgForMe = isATaggedMsg(
            props.participantName,
            identity,
            each?.comment
          );
          const adjustMyMsg = isSameUser(identity, each?.identity)
            ? {
                containerPlace: 'flex-end',
                namePlace: 'row-reverse',
                actionAreaPlace: 'flex-end',
              }
            : {
                containerPlace: 'flex-start',
                namePlace: 'row',
                actionAreaPlace: 'flex-start',
              };
          return (
            <Paper
              elevation={0}
              className={classes.root}
              key={index}
              style={{
                justifyContent: adjustMyMsg?.containerPlace,
                opacity: '',
              }}
            >
              <div
                className={classes.actionArea}
                style={{
                  justifyContent: adjustMyMsg?.actionAreaPlace,
                }}
              >
                <div
                  className={classes.content}
                  style={{
                    backgroundColor: isMsgForMe ? taggedContColor : '#fff',
                  }}
                >
                  <div
                    className={classes.nameContainer}
                    style={{ flexDirection: adjustMyMsg?.namePlace }}
                  >
                    <Typography
                      variant="body1"
                      component="p"
                      className={classes.nameClass}
                    >
                      {each?.name}
                    </Typography>
                    <Typography
                      variant="caption"
                      component="span"
                      className={classes.time}
                    >
                      {/* {each?.time} */}
                    </Typography>
                  </div>
                  {/* <div
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      // width: '3rem',
                    }}
                  > */}
                  <Typography
                    variant="body2"
                    noWrap={false}
                    component="p"
                    className={classes.msgClass}
                  >
                    {/* {each?.comment} */}

                    {manageMsg(each?.comment)}
                  </Typography>
                </div>
              </div>
              {/* </div> */}
            </Paper>
          );
        })}

        {/* <button
        className= {classes.closeBtn}
        >
          <CloseIcon className= {classes.cancelIcon} />
        </button> */}
      </div>
    </Grid>
  );
}

export default Comment;
